var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_497_406",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_497_406)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -1,
    width: 21,
    height: 21,
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_497_406",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_497_406",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAvgAAAL4BsOPnlwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAALBSURBVEiJjdVPiNVVFAfwzx1Hm+Fhhi1UogHDebRRaqiF9hYhGMyiPzAy0cBIuYs2LYQMpk22URrbuWhhSGAwGDoTLSSTREJRCUFFsYVMEZJCRGEGRcfF7wz9ePPe8z04vPPn+z3n3nPvPT8RoR/BVnybsrVf3qAuv1JKM5M+iafxHN7O8GellEu4gZ9xLiJudsyTq2tPPogrWMBvuI25iPg740OYxAasxSvYHBH/9lvgDbwcEVNpP4MdGEvID/gmIi5n/Ci+iogvliXr0OvVuIQXMIxZ/IgZjKfMpG82Ma3krF6Wry35+mzNTNrHcRiNGmYw/xsZO572THLX9ypwAZOpT+F7DNTin+JwzR5IzFTak7jQq8B5jNb0sVqiMfySMrZUOPXzqY8u6d0KHMJurMCdTPwm/sJ1TKfcSN9bibmTnN041OsdXEEzz+JuRPxXSpnHO/gyIj7PW/MEJnAiMXeT08wcnW8RjuB1FPyKVelv5g4eS7mOZsZWJbYk90g950DbDrbgbFTMq3gx/U+pHtS1lLXpk5iryTmFzb12MI+PcjUt1V1v4Fl8gnUpB3MxjcS0kvNhtq3rIQ/hBOby0A6oruGmDg9yU8YOJHYuuUNdCySx4Gu8mva0aqAdw/spx9I3nZjXklN6vuRakXGcrNlrVLPovZQdWFOLn8R4p1zdht0w/sBp3MvVzkbETxkfwbv+n6bb8WhE3G/P1e178BLOYl+eyxacK6V8nPE9qkM/jd+xMjnzyzJ1adECJtp8LfyZ0mqLTWChrxaVUjbgIjZGxD81/weqawn3ImJfLbYSt/B8RNzuuQPsxX48jpHasLulGmajqS8Nu5HE7sfeh94i1Uf9PhZVn8qd2d8zNcyZ9O1MzGJyvuunQAMrUt+Y5IvYVcPsSt9itpLqsT3S1ztoK7gNlzFc8w2nb9vD+A8Aa+rpfrIkmpwAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/rewardsIcon.a427331105a05a8ac397440b21b2dabb.svg";
export { ForwardRef as ReactComponent };